import { initialize } from "@imminently/react/ui/core/scrollable";
import { css } from "@/theme";

// override to always be visible
const override = css`
  scrollbar-color: var(--thumb-color) transparent;

  &::-webkit-scrollbar-thumb {
    display: block;
  }
`;

const scrollables = initialize({ classNamePrefix: "trier", cssOverride: override.styles });

export const { scrollableClassName: scrollable, GlobalStyleJSX: ScrollableStyleJSX, scrollableMixin } = scrollables;